import { openBlock as u, createElementBlock as r, normalizeClass as h, withKeys as b, createElementVNode as f, createBlock as w, Suspense as x, withCtx as m, renderSlot as c, mergeProps as I, createVNode as L, Transition as k, createCommentVNode as g, Fragment as E, renderList as A, toDisplayString as F } from "vue";
const y = {
  selectionUp: [38],
  selectionDown: [40],
  select: [13],
  hideList: [27],
  showList: [40],
  autocomplete: [32, 13]
}, T = {
  input: String,
  select: Object
};
function C(e, t) {
  return t.split(".").reduce((s, n) => s === Object(s) ? s[n] : s, e);
}
function a(e, t) {
  return v(e, t.keyCode);
}
function v(e, t) {
  if (e.length <= 0)
    return !1;
  const s = (n) => n.some((i) => i === t);
  return Array.isArray(e[0]) ? e.some((n) => s(n)) : s(e);
}
const P = /^on[^a-z]/;
function O(e) {
  return P.test(e);
}
function S(e, t) {
  return typeof e < "u" ? C(e, t) : e;
}
const q = (e, t) => {
  const s = e.__vccOpts || e;
  for (const [n, i] of t)
    s[n] = i;
  return s;
}, B = {
  name: "VueSimpleSuggest",
  inheritAttrs: !1,
  props: {
    styles: { type: Object, default: () => ({}) },
    controls: { type: Object, default: () => y },
    minLength: { type: Number, default: 1 },
    maxSuggestions: { type: Number, default: 10 },
    displayAttribute: { type: String, default: "title" },
    valueAttribute: { type: String, default: "id" },
    list: { type: [Function, Array], default: () => [] },
    removeList: { type: Boolean, default: !1 },
    destyled: { type: Boolean, default: !1 },
    filterByQuery: { type: Boolean, default: !1 },
    filter: { type: Function, default: null },
    debounce: { type: Number, default: 0 },
    nullableSelect: { type: Boolean, default: !1 },
    modelValue: { type: [String, Number], default: "" },
    modelSelect: { type: [String, Number, Object], default: null },
    mode: { type: String, default: "input", validator: (e) => !!~Object.keys(T).indexOf(e.toLowerCase()) },
    preventHide: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:modelSelect", "hover", "hide-list", "show-list", "suggestion-click", "blur", "focus", "request-start", "request-done", "request-failed"],
  data(e) {
    return {
      filterResult: null,
      selected: null,
      hovered: null,
      suggestions: [],
      listShown: !1,
      inputElement: null,
      canSend: !0,
      timeoutInstance: null,
      text: e.modelValue,
      isPlainSuggestion: !1,
      isClicking: !1,
      isInFocus: !1,
      isFalseFocus: !1,
      isTabbed: !1,
      controlScheme: {},
      listId: `${this.$.uid}-suggestions`
    };
  },
  computed: {
    listIsRequest() {
      return typeof this.list == "function";
    },
    hoveredIndex() {
      for (let e = 0; e < this.suggestions.length; e++) {
        const t = this.suggestions[e];
        if (this.hovered && this.valueProperty(this.hovered) === this.valueProperty(t))
          return e;
      }
      return -1;
    },
    textLength() {
      return this.text && this.text.length || this.inputElement && this.inputElement.value.length || 0;
    },
    isSelectedUpToDate() {
      return !!this.selected && this.displayProperty(this.selected) === this.text;
    },
    attrsWithoutListeners() {
      const e = {};
      return Object.keys(this.$attrs).forEach((t) => !O(t) && (e[t] = this.$attrs[t])), e;
    },
    field() {
      return Object.assign({}, this.attrsWithoutListeners, {
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onInput: this.onInput,
        onClick: this.showSuggestions,
        onKeydown: this.onKeyDown,
        onKeyup: this.onListKeyUp
      });
    },
    componentField() {
      return Object.assign({}, this.attrsWithoutListeners, {
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        "onUpdate:modelValue": this.onInput,
        onClick: this.showSuggestions,
        onKeydown: this.onKeyDown,
        onKeyup: this.onListKeyUp
      });
    }
  },
  watch: {
    mode: {
      handler() {
        this.$nextTick(() => {
          this.$emit("update:modelValue", this.text), this.$emit("update:modelSelect", this.selected);
        });
      },
      immediate: !0
    },
    filter: {
      handler(e) {
        e != null ? this.filterResult = e : this.filterResult = this.filterDefault;
      },
      immediate: !0
    },
    modelValue: {
      handler(e) {
        this.mode === "input" && (typeof e != "string" && (e = this.displayProperty(e)), this.updateTextOutside(e));
      },
      immediate: !0
    },
    modelSelect: {
      handler(e) {
        this.mode === "select" && (e === null ? this.updateTextOutside("") : (typeof e != "string" && (e = this.displayProperty(e)), this.updateTextOutside(e)));
      },
      immediate: !0
    }
  },
  created() {
    this.controlScheme = Object.assign({}, y, this.controls);
  },
  methods: {
    onResolve() {
      this.$nextTick(() => {
        this.inputElement = this.$refs.inputSlot.querySelector("input"), this.inputElement ? this.setInputAriaAttributes() : console.error("No input element found");
      });
    },
    isEqual(e, t) {
      return t && this.valueProperty(e) === this.valueProperty(t);
    },
    isSelected(e) {
      return this.isEqual(e, this.selected);
    },
    isHovered(e) {
      return this.isEqual(e, this.hovered);
    },
    setInputAriaAttributes() {
      this.inputElement && (this.inputElement.setAttribute("aria-activedescendant", ""), this.inputElement.setAttribute("aria-autocomplete", "list"), this.inputElement.setAttribute("aria-controls", this.listId));
    },
    isScopedSlotEmpty(e) {
      return e ? e(this).some((s) => s.type === Comment || Array.isArray(s.children) && !s.children.length ? !1 : s.type !== Text || typeof s.children == "string" && s.children.trim() !== "") : !0;
    },
    miscSlotsAreEmpty() {
      const e = ["misc-item-above", "misc-item-below"].map((s) => this.$slots[s]);
      if (e.every((s) => !!s))
        return e.every(this.isScopedSlotEmpty.bind(this));
      const t = e.find((s) => !!s);
      return this.isScopedSlotEmpty(t);
    },
    displayProperty(e) {
      if (this.isPlainSuggestion)
        return e;
      const t = S(e, this.displayAttribute);
      return typeof t > "u" && "production".indexOf("dev") && console.error(
        `[vue-simple-suggest]: Please, check if you passed 'value-attribute' (default is 'id') and 'display-attribute' (default is 'title') props correctly.
        Your list objects should always contain a unique identifier.`
      ), t;
    },
    valueProperty(e) {
      if (this.isPlainSuggestion)
        return e;
      const t = S(e, this.valueAttribute);
      return typeof t > "u" && "production".indexOf("dev") && console.error(
        `[vue-simple-suggest]: Please, check if you passed 'value-attribute' (default is 'id') and 'display-attribute' (default is 'title') props correctly.
        Your list objects should always contain a unique identifier.`
      ), t;
    },
    autocompleteText(e) {
      this.setText(this.displayProperty(e));
    },
    setText(e) {
      this.$nextTick(() => {
        this.inputElement && (this.inputElement.value = e), this.text = e, this.$emit("update:modelValue", e);
      });
    },
    select(e) {
      (e && this.selected !== e || this.nullableSelect && !e) && (this.selected = e, this.$emit("update:modelSelect", e), e && this.autocompleteText(e)), this.hover(null);
    },
    hover(e, t) {
      const s = e ? this.getId(e, this.hoveredIndex) : "";
      this.inputElement && this.inputElement.setAttribute("aria-activedescendant", s), e && e !== this.hovered && this.$emit("hover", e, t), this.hovered = e;
    },
    hideList() {
      this.listShown && (this.listShown = !1, this.hover(null), this.$emit("hide-list"));
    },
    showList() {
      this.listShown || this.textLength >= this.minLength && (this.suggestions.length > 0 || !this.miscSlotsAreEmpty()) && (this.listShown = !0, this.$emit("show-list"));
    },
    async showSuggestions() {
      this.suggestions.length === 0 && this.minLength <= this.textLength && (this.showList(), await this.research()), this.showList();
    },
    onShowList(e) {
      a(this.controlScheme.showList, e) && this.showSuggestions();
    },
    moveSelection(e) {
      if (!(!this.listShown || !this.suggestions.length) && a([this.controlScheme.selectionUp, this.controlScheme.selectionDown], e)) {
        e.preventDefault();
        const t = a(this.controlScheme.selectionDown, e), s = t * 2 - 1, n = t ? 0 : this.suggestions.length - 1, i = t ? this.hoveredIndex < this.suggestions.length - 1 : this.hoveredIndex > 0;
        let l = null;
        this.hovered ? i ? l = this.suggestions[this.hoveredIndex + s] : l = this.suggestions[n] : l = this.selected || this.suggestions[n], this.hover(l);
      }
    },
    onKeyDown(e) {
      const t = this.controlScheme.select, s = this.controlScheme.hideList;
      e.key === "Enter" && this.listShown && v([t, s], 13) && e.preventDefault(), e.key === "Tab" && this.hovered && this.select(this.hovered), this.onShowList(e), this.moveSelection(e), this.onAutocomplete(e);
    },
    onListKeyUp(e) {
      const t = this.controlScheme.select, s = this.controlScheme.hideList;
      this.listShown && a([t, s], e) && (e.preventDefault(), a(t, e) && this.select(this.hovered), this.hideList());
    },
    onAutocomplete(e) {
      a(this.controlScheme.autocomplete, e) && (e.ctrlKey || e.shiftKey) && this.suggestions.length > 0 && this.suggestions[0] && this.listShown && (e.preventDefault(), this.hover(this.suggestions[0]), this.autocompleteText(this.suggestions[0]));
    },
    suggestionClick(e, t) {
      this.$emit("suggestion-click", e, t), this.select(e), this.preventHide || this.hideList(), this.isClicking && setTimeout(() => {
        this.inputElement && this.inputElement.focus(), this.isClicking = !1;
      }, 0);
    },
    onBlur(e) {
      this.isInFocus ? (this.isClicking = this.hovered && !this.isTabbed, this.isClicking ? e && e.isTrusted && !this.isTabbed && (this.isFalseFocus = !0) : (this.isInFocus = !1, this.hideList(), this.$emit("blur", e))) : (this.inputElement && this.inputElement.blur(), console.error(
        `This should never happen!
          If you encountered this error, please make sure that your input component emits 'focus' events properly.
          For more info see https://github.com/KazanExpress/vue-simple-suggest#custom-input.

          If your 'vue-simple-suggest' setup does not include a custom input component - please,
          report to https://github.com/KazanExpress/vue-simple-suggest/issues/new`
      )), this.isTabbed = !1;
    },
    onFocus(e) {
      this.isInFocus = !0, e && !this.isFalseFocus && this.$emit("focus", e), !this.isClicking && !this.isFalseFocus && this.showSuggestions(), this.isFalseFocus = !1;
    },
    onInput(e) {
      const t = e.target ? e.target.value : e;
      this.updateTextOutside(t), this.$emit("update:modelValue", t);
    },
    updateTextOutside(e) {
      if (this.text !== e) {
        if (this.text = e, this.hovered && this.hover(null), this.text.length < this.minLength) {
          this.hideList();
          return;
        }
        this.debounce ? (clearTimeout(this.timeoutInstance), this.timeoutInstance = setTimeout(this.research, this.debounce)) : this.research();
      }
    },
    async research() {
      try {
        if (this.canSend) {
          this.canSend = !1;
          const e = this.text, t = await this.getSuggestions(this.text);
          e === this.text && (this.suggestions = t);
        }
      } catch (e) {
        throw this.clearSuggestions(), e;
      } finally {
        return this.canSend = !0, this.suggestions.length === 0 && this.miscSlotsAreEmpty() ? this.hideList() : this.isInFocus && this.showList(), this.suggestions;
      }
    },
    async getSuggestions(e) {
      if (e = e || "", e.length < this.minLength)
        return [];
      this.selected = null, this.listIsRequest && this.$emit("request-start", e);
      let t = !1, s = [];
      try {
        this.listIsRequest ? s = await this.list(e) || [] : s = this.list, Array.isArray(s) || (s = [s]), t = typeof s[0] != "object" && typeof s[0] < "u" || Array.isArray(s[0]), this.filterByQuery && (s = s.filter((n) => this.filterResult(n, e))), this.listIsRequest && this.$emit("request-done", s);
      } catch (n) {
        if (this.listIsRequest)
          this.$emit("request-failed", n);
        else
          throw n;
      } finally {
        return this.maxSuggestions && (s = s.slice(0, this.maxSuggestions)), this.isPlainSuggestion = t, s;
      }
    },
    clearSuggestions() {
      this.suggestions.splice(0);
    },
    getId(e, t) {
      return `${this.listId}-suggestion-${this.isPlainSuggestion ? t : this.valueProperty(e) || t}`;
    },
    filterDefault(e, t) {
      return t ? this.displayProperty(e).toLowerCase().indexOf(t.toLowerCase()) > -1 : !0;
    }
  }
}, K = ["aria-owns", "aria-expanded"], D = ["value"], R = ["id", "aria-labelledby"], V = ["id", "aria-selected", "onMouseenter", "onClick"];
function j(e, t, s, n, i, l) {
  return u(), r("div", {
    class: h(["vue-simple-suggest", [s.styles.vueSimpleSuggest, { designed: !s.destyled, focus: i.isInFocus }]]),
    onKeydown: t[1] || (t[1] = b((o) => i.isTabbed = !0, ["tab"]))
  }, [
    f("div", {
      ref: "inputSlot",
      class: h(["input-wrapper", s.styles.inputWrapper]),
      role: "combobox",
      "aria-haspopup": "listbox",
      "aria-owns": i.listId,
      "aria-expanded": i.listShown && !s.removeList ? "true" : "false"
    }, [
      (u(), w(x, { onResolve: l.onResolve }, {
        default: m(() => [
          c(e.$slots, "default", {
            field: l.field,
            componentField: l.componentField
          }, () => [
            f("input", I({ class: "default-input" }, l.field, {
              value: i.text || "",
              class: s.styles.defaultInput
            }), null, 16, D)
          ])
        ]),
        fallback: m(() => [
          c(e.$slots, "fallback")
        ]),
        _: 3
      }, 8, ["onResolve"]))
    ], 10, K),
    L(k, { name: "vue-simple-suggest" }, {
      default: m(() => [
        i.listShown && !s.removeList ? (u(), r("ul", {
          key: 0,
          id: i.listId,
          class: h(["suggestions", s.styles.suggestions]),
          role: "listbox",
          "aria-labelledby": i.listId
        }, [
          e.$slots["misc-item-above"] ? (u(), r("li", {
            key: 0,
            class: h(s.styles.miscItemAbove)
          }, [
            c(e.$slots, "misc-item-above", {
              suggestions: i.suggestions,
              query: i.text
            })
          ], 2)) : g("", !0),
          (u(!0), r(E, null, A(i.suggestions, (o, p) => (u(), r("li", {
            id: l.getId(o, p),
            key: l.getId(o, p),
            class: h(["suggest-item", [s.styles.suggestItem, { selected: l.isSelected(o), hover: l.isHovered(o) }]]),
            role: "option",
            "aria-selected": l.isHovered(o) || l.isSelected(o) ? "true" : "false",
            onMouseenter: (d) => l.hover(o, d.target),
            onMouseleave: t[0] || (t[0] = (d) => l.hover(null)),
            onClick: (d) => l.suggestionClick(o, d)
          }, [
            c(e.$slots, "suggestion-item", {
              autocomplete: () => l.autocompleteText(o),
              suggestion: o,
              query: i.text
            }, () => [
              f("span", null, F(l.displayProperty(o)), 1)
            ])
          ], 42, V))), 128)),
          e.$slots["misc-item-below"] ? (u(), r("li", {
            key: 1,
            class: h(s.styles.miscItemBelow)
          }, [
            c(e.$slots, "misc-item-below", {
              suggestions: i.suggestions,
              query: i.text
            })
          ], 2)) : g("", !0)
        ], 10, R)) : g("", !0)
      ]),
      _: 3
    })
  ], 34);
}
const _ = /* @__PURE__ */ q(B, [["render", j]]);
export {
  _ as default
};
